import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { A } from '#app/components/typography/a.tsx'
import { H1 } from '#app/components/typography/h1.tsx'
import { P } from '#app/components/typography/p.tsx'
import { sessionKey } from '#app/utils/auth.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { authSessionStorage } from '#app/utils/session.server.ts'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H1',
}

const component: componentProps = {
	name: 'H1',
	shortName: 'H1',
	fileName: 'h1',
	category: 'typography',
	description: ['H1 heading component.'],
	features: ['Drop-in replacement for the native <h1> element.', "Opts-in to your typographic system's styles."],
	usage: `<H1>This is an H1 heading</H1>`,
	parts: [
		{
			name: 'h1',
			description: 'Drop-in replacement component for the native <h1> element.',
			props: [],
			state: [],
			events: [],
			layout: [],
			accessibility: [],
		},
	],
	styling: ``,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const authSession = await authSessionStorage.getSession(request.headers.get('cookie'))
	const sessionId = authSession.get(sessionKey)
	const session =
		sessionId ?
			await prisma.session.findUnique({
				select: { user: { select: { id: true, paid: true } } },
				where: { id: sessionId, expirationDate: { gt: new Date() } },
			})
		:	null
	const source = session?.user.paid ? await readSource({ category: component.category, fileName: component.fileName }) : null
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<P>
				If you're wondering why this component exists, read the <A href="/components/typography">typography intro</A>.
			</P>
			<Features features={features} />
			<Usage usage={usage} shortName={shortName} />
			<H1>This is an H1 heading</H1>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
